import { push } from '@lagunovsky/redux-react-router'
import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import useLocalStorage from '../../app/hooks/useLocalStorage'
import FormLogin from '../../components/Forms/FormLogin/FormLogin'
import FormWithoutLogin from '../../components/Forms/FormWithoutLogin/FormWithoutLogin'
import OrderStepsHeader from '../../components/OrderStepsHeader/OrderStepsHeader'
import { PAGE_NAME } from '../../components/OrderStepsHeader/constants'
import InfoWindow from '../../components/Windows/InfoWindow/InfoWindow'
import useErrorMessage from '../../components/Windows/InfoWindow/hooks/useErrorMessage'
import { getCinemaSlug } from '../Hall/helpers'
import ChooseHeader from './components/ChooseHeader/ChooseHeader'

import hocConnect from '../Login/hocLogin'
import hocContactInfo from './hocContactInfo'

import useSendBasketGtmInfo from 'services/gtm/useSendBasketGtmInfo'
import './ContactInfo.scss'

const ContactInfo = ({
    isAuth,
    emptyBasket,
    loading,
    error,
    login,
    loginUsingFacebook,
    loginUsingGoogle,
    loginUsingApple,
    loginSocialsError,
    selectedPayment,
    eventid,
    cinemaid,
    basketData,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()
    const [isLoginForm, setIsLoginForm] = useState(true)
    const errorMessage = useErrorMessage(error?.message)
    const [, setUserInfo] = useLocalStorage('user-info', null)

    const onSubmitWithoutLogin = (values) => {
        setUserInfo(values)
        dispatch(push(`/${PAGE_NAME.orderSummary}`))
    }

    const site = getCinemaSlug(cinemaid)

    useSendBasketGtmInfo(basketData, site, 'add_shipping_info')

    //TODO finish logic ... not always there are data with emptyBasket
    // if (emptyBasket || isAuth) dispatch(push('/not-found'))

    return (
        <Container fluid className={'contact-info-page d-flex flex-column'}>
            <OrderStepsHeader
                eventid={eventid}
                site={site}
                loading={loading}
                emptyBasket={emptyBasket}
                active={PAGE_NAME.contactInfo}
                selectedPayment={selectedPayment}
                text={intl.formatMessage({ id: 'orderSteps.third' })}
                onClickBack={() => dispatch(push(`/${PAGE_NAME.yourOrder}`))}
            />
            <div className={'contact-info-page--content d-flex flex-column mx-auto'}>
                {error && <InfoWindow color={'red'} description={errorMessage} withScroll withTimer />}

                <div className={'contact-info-page--forms d-flex'}>
                    <ChooseHeader isLoginForm={isLoginForm} setIsLoginForm={setIsLoginForm} />
                    {isLoginForm ? (
                        <FormLogin
                            title={intl.formatMessage({ id: 'contactInfo.haveAccount' })}
                            handleSubmit={login}
                            handleGoogle={loginUsingGoogle}
                            handleFacebook={loginUsingFacebook}
                            handleApple={loginUsingApple}
                            handleSocialsError={loginSocialsError}
                            formErrors={error}
                            loading={loading}
                        />
                    ) : (
                        <FormWithoutLogin
                            title={intl.formatMessage({ id: 'contactInfo.buyWithoutLogin' })}
                            handleSubmit={(values) => onSubmitWithoutLogin(values)}
                        />
                    )}
                    <FormWithoutLogin
                        title={intl.formatMessage({ id: 'contactInfo.buyWithoutLogin' })}
                        className={'without-login'}
                        handleSubmit={(values) => onSubmitWithoutLogin(values)}
                    />
                </div>
            </div>
            <img
                src={'images/cinestar/astronaut-cola.png'}
                alt={'astronaut-cola'}
                className={'astronaut-animate w-50 h-auto mx-auto'}
            />
        </Container>
    )
}

export default hocContactInfo(hocConnect(ContactInfo))
